var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconPen = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "var(--tool-color-dark)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4306 9.92487C16.2031 7.87866 14.8435 5.6131 14.8435 5.6131C14.7164 5.40143 14.4877 5.27179 14.2407 5.27179H9.72186C9.47504 5.27179 9.24615 5.40143 9.11908 5.6131C9.11908 5.6131 7.75952 7.87866 6.53198 9.92487C5.32166 11.9421 4.63116 14.2258 4.51709 16.5687H19.4455C19.3316 14.2258 18.6409 11.9421 17.4306 9.92487Z",
    fill: "var(--tool-color-dark)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1907 2.20935C14.1907 0.99115 13.1995 0 11.9813 0C10.7629 0 9.77197 0.99115 9.77197 2.20935V3.86554H14.1907V2.20935Z",
    fill: "var(--tool-color-dark)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.9751V23.2969C4.5 23.6852 4.81476 24 5.20312 24H18.7593C19.1477 24 19.4625 23.6852 19.4625 23.2969V17.9751H4.5Z",
    fill: "var(--tool-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pen.1db556a2.svg";
export { ForwardRef as ReactComponent };